import Vue from 'vue'
import Router from 'vue-router'

const login = () => import('views/login/login');
const layout = () => import('components/Layout');
const home = () => import('views/home/home');
const commission = () => import('views/commission/commission');
const inform = () => import('views/inform/inform');

// 待办项
const commissionDivision = () => import('views/commission/components/division');
const commissionPlace = () => import('views/commission/components/place');
const commissionCase = () => import('views/commission/components/case');
const commissionAward = () => import('views/commission/components/award');
const commissionAudit = () => import('views/commission/components/audit');
const commissionDirector = () => import('views/commission/components/director');

// 通知
const informAll = () => import('views/inform/components/all');
const informRead = () => import('views/inform/components/read');
const informUnread = () => import('views/inform/components/unread');

// 立案管理
// const establish = () => import('views/establish/establish');
// 立案管理 -> 分案管理
const establisDivision = () => import('views/establish/division/division');
// 立案管理 -> 立案管理
const establisPlace = () => import('views/establish/place/place');

// 值班管理
// 值班管理 -> 值班列表
const duty = () => import('views/duty/duty');
const dutyPerson = () => import('views/duty/person');



// 办案管理
// const transact = () => import('views/transact/transact');
// 办案管理 -> 案件管理
const transactCase = () => import('views/transact/case/case/case');
const transactGroup = () => import('views/transact/case/group/group');
const transactCaseDone = () => import('views/transact/case/caseDone/caseDone');
const transactDraft = () => import('views/transact/case/case/draft');
//预览
const preView = () => import('views/transact/case/case/preView');
const editRecode = () => import('views/transact/case/case/recode');
const query = () => import('views/transact/case/query/query');
const caseExport = () => import('views/transact/case/export/export');
const fast = () => import('views/transact/case/fast/fast');
const director = () => import('views/transact/case/director/director');

const award = () => import('views/transact/case/award/award');
const apply = () => import('views/transact/case/apply/apply');
const transactAudit = () => import('views/transact/case/audit/audit');
const extendAudit = () => import('views/transact/case/extend/audit');

// 办案管理 -> 案件初检
const placeCheck = () => import('views/transact/check/placeCheck/placeCheck');
const draftCheck = () => import('views/transact/check/draftCheck/draftCheck');

const emailDetails = () => import('views/transact/case/case/emailDetails');
const caseDetails = () => import('views/caseDetails/caseDetails');
// 查看仲裁通知
const letterView = () => import('views/caseDetails/showPages/letterView.vue');
const replyShow = () => import('views/caseDetails/showPages/replyShow.vue');
const otherView = () => import('views/caseDetails/showPages/otherView.vue');
// 系统管理
// const system = () => import('views/system/system');
// 系统管理 -> 系统管理
const sysFunc = () => import('views/system/sysManager/func/func');
const sysRole = () => import('views/system/sysManager/role/role');
const sysUser = () => import('views/system/sysManager/user/user');
const sysData = () => import('views/system/sysManager/data/data');
const sysLetters = () => import('views/system/sysManager/letters/letters');
const sysNewLetters = () => import('views/system/sysManager/letters/newLetters');
const sysEditLetters = () => import('views/system/sysManager/letters/editLetters');
const sysCost = () => import('views/system/sysManager/cost/cost');
const sysServerCost = () => import('views/system/sysManager/serverCost/serverCost');
const sysFlow = () => import('views/system/sysManager/flow/flow');
const sysPowerFlow = () => import('views/system/sysManager/powerFlow/powerFlow');
const sysDoPowerFlow = () => import('views/system/sysManager/powerFlow/doPowerFlow');
const sysArbitrator = () => import('views/system/sysManager/arbitrator/arbitrator');
const arbitratorNew = () => import('views/system/sysManager/arbitrator/newArbitrator');
const arbitratorView = () => import('views/system/sysManager/arbitrator/viewArbitrator');
const sysFee = () => import('views/system/sysManager/fee/fee');
const feeDetail = () => import('views/system/sysManager/fee/feeDetail');
const sysLog = () => import('views/system/sysManager/log/log');
const recharge = () => import('src/views/system/sysManager/recharge/recharge');

// 缴费管理
const payedList = () => import('views/system/payManager/payedList/payedList');
const payList = () => import('views/system/payManager/payList/payList');

// 对账管理
const reconciliationList = () => import('views/system/payManager/reconciliation/reconciliation');
const reconciliationLine = () => import('views/system/payManager/reconciliation/lineList');
const unlineCheck = () => import('views/system/payManager/reconciliation/unlineDetail');
const reconciliationChecked = () => import('views/system/payManager/reconciliation/checked');
//  站内信
const message = () => import('views/message');

//  电子送达
const deliveryCase = () => import('views/delivery/caseMail');
const deliveryMail = () => import('views/delivery/mail');
const deliveryMseeage = () => import('views/delivery/message');
const deliveryDetail = () => import('views/delivery/detail');
const caseDelivery = () => import('views/delivery/case');

//  结案管理
const caseDoneGmt = () => import('views/transact/case/caseDoneGmt/list');
const waitList = () => import('views/transact/case/caseDoneGmt/waitList');


Vue.use(Router);

export default new Router({
  mode: 'history',
  routes: [
    { path: '/', redirect: '/home' },
    {
      path: '/login',
      name: 'login',
      component: login
    },
    {
      path: '/layout',
      name: 'layout',
      component: layout,
      redirect: '/home',
      children: [
        // 立案管理
        {
          path: '/home',
          name: 'home',
          component: home
        },
        // 立案管理

        // 立案管理 -> 分案管理
        {
          path: '/establish/division/division',
          name: 'establisDivision',
          component: establisDivision
        },
        {
          path: '/transact/case/case/emailDetails',
          name: 'emailDetails',
          component: emailDetails
        },
        {
          path: '/transact/case/caseDone/emailDetails',
          name: 'emailDetailsDone',
          component: emailDetails
        },
        {
          path: '/establish/division/division/details',
          name: 'divisionCaseDetails',
          component: caseDetails
        },
        {
          path: '/establish/division/division/letter',
          name: 'divisionLetterView',
          component: letterView
        },
        {
          path: '/establish/division/division/otherView',
          name: 'divisionOtherView',
          component: otherView
        },

        {
          path: '/establish/division/division/reply',
          name: 'divisionReplyShow',
          component: replyShow
        },
        // 立案管理 -> 立案管理
        {
          path: '/establish/place/place',
          name: 'establisPlace',
          component: establisPlace
        },
        {
          path: '/establish/place/place/details',
          name: 'placeCaseDetails',
          component: caseDetails
        },
        {
          path: '/establish/place/place/letter',
          name: 'placeLetterView',
          component: letterView
        },
        {
          path: '/establish/place/place/otherView',
          name: 'placeOtherView',
          component: otherView
        },
        {
          path: '/establish/place/place/reply',
          name: 'placeReplyShow',
          component: replyShow
        },
        // 值班管理
        {
          path: '/dutyManage/dutyPerson',
          name: 'dutyPerson',
          component: dutyPerson
        },
        {
          path: '/dutyManage/duty',
          name: 'duty',
          component: duty
        },
        {
          path: '/dutyManage/duty/details',
          name: 'dutyCaseDetails',
          component: caseDetails
        },
        {
          path: '/dutyManage/duty/letter',
          name: 'dutyLetterView',
          component: letterView
        },
        {
          path: '/dutyManage/duty/otherView',
          name: 'dutyOtherView',
          component: otherView
        },
        {
          path: '/dutyManage/duty/reply',
          name: 'dutyReplyShow',
          component: replyShow
        },
        // 办案管理
        // 办案管理 -> 案件管理
        {
          path: '/transact/case/case',
          name: 'transactCase',
          component: transactCase
        },

        {
          path: '/transact/case/case/details',
          name: 'caseDetails',
          component: caseDetails
        },
        {
          path: '/transact/case/case/letter',
          name: 'caseLetterView',
          component: letterView
        },
        {
          path: '/transact/case/case/otherView',
          name: 'caseOtherView',
          component: otherView
        },
        {
          path: '/transact/case/case/reply',
          name: 'caseReplyShow',
          component: replyShow
        },

        // 办案管理 -> 组庭列表
        {
          path: '/transact/case/group',
          name: 'transactGroup',
          component: transactGroup
        },

        {
          path: '/transact/case/group/details',
          name: 'groupDetails',
          component: caseDetails
        },
        {
          path: '/transact/case/group/letter',
          name: 'groupLetterView',
          component: letterView
        },
        {
          path: '/transact/case/group/otherView',
          name: 'groupOtherView',
          component: otherView
        },
        {
          path: '/transact/case/group/reply',
          name: 'groupReplyShow',
          component: replyShow
        },

        // 办案管理 -> 已结案件
        {
          path: '/transact/case/caseDone',
          name: 'transactCaseDone',
          component: transactCaseDone
        },

        {
          path: '/transact/case/caseDone/details',
          name: 'caseDoneDetails',
          component: caseDetails
        },
        {
          path: '/transact/case/caseDone/letter',
          name: 'caseDoneLetterView',
          component: letterView
        },
        {
          path: '/transact/case/caseDone/otherView',
          name: 'caseDoneOtherView',
          component: otherView
        },
        {
          path: '/transact/case/caseDone/reply',
          name: 'caseDoneReplyShow',
          component: replyShow
        },
        // 案件管理 -> 主任管理
        {
          path: '/transact/case/director',
          name: 'director',
          component: director
        },

        {
          path: '/transact/case/director/details',
          name: 'directorDetails',
          component: caseDetails
        },
        {
          path: '/transact/case/director/letter',
          name: 'directorLetterView',
          component: letterView
        },
        {
          path: '/transact/case/director/otherView',
          name: 'directorOtherView',
          component: otherView
        },
        {
          path: '/transact/case/director/reply',
          name: 'directorReplyShow',
          component: replyShow
        },

        {
          path: '/transact/case/case/draft',
          name: 'transactDraft',
          component: transactDraft
        },
        {
          path: '/transact/case/case/editDraft',
          name: 'editDraft',
          component: transactDraft
        },
        {
          path: '/transact/case/award',
          name: 'award',
          component: award
        },
        {
          path: '/transact/case/award/editDraft',
          name: 'awardEditDraft',
          component: transactDraft
        },
        {
          path: '/transact/case/case/recode',
          name: 'editRecode',
          component: editRecode
        },
        {
          path: '/transact/case/award/details',
          name: 'awardCaseDetails',
          component: caseDetails
        },
        {
          path: '/transact/case/award/letter',
          name: 'awardLetterView',
          component: letterView
        },
        {
          path: '/transact/case/award/otherView',
          name: 'awardOtherView',
          component: otherView
        },
        {
          path: '/transact/case/award/reply',
          name: 'awardReplyShow',
          component: replyShow
        },
        {
          path: '/transact/case/query',
          name: 'query',
          component: query
        },
        {
          path: '/transact/case/query/details',
          name: 'queryCaseDetails',
          component: caseDetails
        },
        {
          path: '/transact/case/query/otherView',
          name: 'queryOtherView',
          component: otherView
        },
        {
          path: '/transact/case/query/reply',
          name: 'queryReplyShow',
          component: replyShow
        },
        {
          path: '/transact/case/fast',
          name: 'fast',
          component: fast
        },
        {
          path: '/transact/case/fast/details',
          name: 'fastCaseDetails',
          component: caseDetails
        },
        {
          path: '/transact/case/fast/letter',
          name: 'fastLetterView',
          component: letterView
        },
        {
          path: '/transact/case/fast/otherView',
          name: 'fastOtherView',
          component: otherView
        },
        {
          path: '/transact/case/fast/reply',
          name: 'fastReplyShow',
          component: replyShow
        },
        {
          path: '/transact/case/audit',
          name: 'transactAudit',
          component: transactAudit
        },
        {
          path: '/transact/case/audit/details',
          name: 'auditCaseDetails',
          component: caseDetails
        },
        {
          path: '/transact/case/audit/letter',
          name: 'auditLetterView',
          component: letterView
        },
        {
          path: '/transact/case/audit/otherView',
          name: 'auditOtherView',
          component: otherView
        },
        {
          path: '/transact/case/audit/reply',
          name: 'auditReplyShow',
          component: replyShow
        },
        {
          path: '/transact/case/extend',
          name: 'extendAudit',
          component: extendAudit
        },
        {
          path: '/transact/case/extend/details',
          name: 'extendCaseDetails',
          component: caseDetails
        },
        {
          path: '/transact/case/extend/letter',
          name: 'extendLetterView',
          component: letterView
        },
        {
          path: '/transact/case/extend/otherView',
          name: 'extendOtherView',
          component: otherView
        },
        {
          path: '/transact/case/extend/reply',
          name: 'extendReplyShow',
          component: replyShow
        },

        {
          path: '/transact/case/export',
          name: 'caseExport',
          component: caseExport
        },

        // 其他申请
        {
          path: '/transact/case/apply',
          name: 'apply',
          component: apply
        },

        // 初检管理 -> 立案初检列表
        {
          path: '/transact/check/placeCheck',
          name: 'placeCheck',
          component: placeCheck
        },

        {
          path: '/transact/check/placeCheck/details',
          name: 'placeCheckDetails',
          component: caseDetails
        },
        {
          path: '/transact/check/placeCheck/letter',
          name: 'placeCheckLetterView',
          component: letterView
        },
        {
          path: '/transact/check/placeCheck/otherView',
          name: 'placeCheckOtherView',
          component: otherView
        },
        {
          path: '/transact/check/placeCheck/reply',
          name: 'placeCheckReplyShow',
          component: replyShow
        },
        // 初检管理 -> 立案初检列表
        {
          path: '/transact/check/draftCheck',
          name: 'draftCheck',
          component: draftCheck
        },

        {
          path: '/transact/check/draftCheck/details',
          name: 'draftCheckDetails',
          component: caseDetails
        },
        {
          path: '/transact/check/draftCheck/letter',
          name: 'draftCheckLetterView',
          component: letterView
        },
        {
          path: '/transact/check/draftCheck/otherView',
          name: 'draftCheckOtherView',
          component: otherView
        },
        {
          path: '/transact/check/draftCheck/reply',
          name: 'draftCheckReplyShow',
          component: replyShow
        },
        // 系统管理
        {
          path: '/system/sysManager/sysFunc',
          name: 'sysFunc',
          component: sysFunc
        },
        {
          path: '/system/sysManager/sysRole',
          name: 'sysRole',
          component: sysRole
        },
        {
          path: '/system/sysManager/sysUser',
          name: 'sysUser',
          component: sysUser
        },
        {
          path: '/system/sysManager/sysData',
          name: 'sysData',
          component: sysData
        },
        {
          path: '/system/sysManager/sysLetters',
          name: 'sysLetters',
          component: sysLetters
        },
        {
          path: '/system/sysManager/sysLetters/new',
          name: 'sysNewLetters',
          component: sysNewLetters
        },
        {
          path: '/system/sysManager/sysLetters/edit',
          name: 'sysEditLetters',
          component: sysEditLetters
        },
        {
          path: '/system/sysManager/sysCost',
          name: 'sysCost',
          component: sysCost
        },
        {
          path: '/system/sysManager/sysFlow',
          name: 'sysFlow',
          component: sysFlow
        },
        {
          path: '/system/sysManager/sysPowerFlow',
          name: 'sysPowerFlow',
          component: sysPowerFlow
        },
        {
          path: '/system/sysManager/sysPowerFlow/do',
          name: 'sysDoPowerFlow',
          component: sysDoPowerFlow
        },
        {
          path: '/system/sysManager/sysArbitrator',
          name: 'sysArbitrator',
          component: sysArbitrator
        },
        {
          path: '/system/sysManager/sysArbitrator/new',
          name: 'arbitratorNew',
          component: arbitratorNew
        },
        {
          path: '/system/sysManager/sysArbitrator/edit',
          name: 'arbitratorEdit',
          component: arbitratorNew
        },
        {
          path: '/system/sysManager/sysArbitrator/view',
          name: 'arbitratorView',
          component: arbitratorView
        },
        {
          path: '/system/sysManager/sysServerCost',
          name: 'sysServerCost',
          component: sysServerCost
        },
        {
          path: '/system/sysManager/sysFee',
          name: 'sysFee',
          component: sysFee
        },
        {
          path: '/system/sysManager/sysFee/detail',
          name: 'feeDetail',
          component: feeDetail
        },
        {
          path: '/system/sysManager/sysLog',
          name: 'sysLog',
          component: sysLog
        },
        {
          path: '/system/sysManager/recharge',
          name: 'recharge',
          component: recharge
        },

        //  缴费管理
        {
          path: '/system/payManager/payedList',
          name: 'payedList',
          component: payedList
        },
        {
          path: '/system/payManager/payList',
          name: 'payList',
          component: payList
        },
        {
          path: '/system/payManager/payList/details',
          name: 'payListCaseDetails',
          component: caseDetails
        },
        {
          path: '/system/payManager/payList/letter',
          name: 'payListLetterView',
          component: letterView
        },
        {
          path: '/system/payManager/payList/otherView',
          name: 'payListOtherView',
          component: otherView
        },
        {
          path: '/system/payManager/payList/reply',
          name: 'payListReplyShow',
          component: replyShow
        },
        //对账管理
        {
          path: '/system/reconciliation/reconciliationList',
          name: 'reconciliationList',
          component: reconciliationList
        },
        {
          path: '/system/reconciliation/reconciliationLine',
          name: 'reconciliationLine',
          component: reconciliationLine
        },
        {
          path: '/system/reconciliation/unlineCheck',
          name: 'unlineCheck',
          component: unlineCheck
        },
        {
          path: '/system/reconciliation/checked',
          name: 'reconciliationChecked',
          component: reconciliationChecked
        },
        {
          path: '/message',
          name: 'message',
          component: message
        },
        {
          path: '/deliveryCase/mail',
          name: 'deliveryCase',
          meta: { keepAlive: true },
          component: deliveryCase
        },
        {
          path: '/deliveryCase/deliveryMail',
          name: 'deliveryMail',
          component: deliveryMail
        },
        {
          path: '/deliveryCase/deliveryMseeage',
          name: 'deliveryMseeage',
          meta: { keepAlive: true },
          component: deliveryMseeage
        },
        {
          path: '/deliveryCase/deliveryMail/deliveryDetail',
          name: 'deliveryDetail',
          component: deliveryDetail
        },
        {
          path: '/deliveryCase/case',
          name: 'caseDelivery',
          component: caseDelivery
        },

        //结案
        {
          path: '/transact/case/caseDoneGmt',
          name: 'caseDoneGmt',
          component: caseDoneGmt
        },
        {
          path: '/transact/caseDoneGmt/waitList',
          name: 'waitList',
          component: waitList
        },
        {
          path: '/transact/caseDoneGmt/waitList/details',
          name: 'waitListCaseDetails',
          component: caseDetails
        },
        {
          path: '/transact/caseDoneGmt/waitList/letter',
          name: 'waitListLetterView',
          component: letterView
        },
        {
          path: '/transact/caseDoneGmt/waitList/otherView',
          name: 'waitListOtherView',
          component: otherView
        },
        {
          path: '/transact/caseDoneGmt/waitList/reply',
          name: 'waitListReplyShow',
          component: replyShow
        },
      ]
    },
    {
      path: '/inform',
      name: 'inform',
      component: inform,
      children: [
        {
          path: '/inform/all',
          name: 'informAll',
          component: informAll
        },
        {
          path: '/inform/unread',
          name: 'informUnread',
          component: informUnread
        },
        {
          path: '/inform/read',
          name: 'informRead',
          component: informRead
        },
      ]
    },
    {
      path: '/commission',
      name: 'commission',
      component: commission,
      children: [
        {
          path: '/commission/division',
          name: 'commissionDivision',
          component: commissionDivision
        },
        {
          path: '/commission/place',
          name: 'commissionPlace',
          component: commissionPlace
        },
        {
          path: '/commission/case',
          name: 'commissionCase',
          component: commissionCase
        },
        {
          path: '/commission/award',
          name: 'commissionAward',
          component: commissionAward
        },
        {
          path: '/commission/audit',
          name: 'commissionAudit',
          component: commissionAudit
        },
        {
          path: '/commission/director',
          name: 'commissionDirector',
          component: commissionDirector
        }
      ]
    },

    //预览
    {
      path: '/transact/case/case/preView',
      name: 'preView',
      component: preView
    },

  ]
})



// WEBPACK FOOTER //
// ./src/router/index.js